// extracted by mini-css-extract-plugin
export default {"logged_in_landing":"LoggedInLanding_logged_in_landing__Hfd1w","landing_description":"LoggedInLanding_landing_description__OeS0z"};